<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i>数据存储</el-breadcrumb-item>
                <el-breadcrumb-item>应用管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='12'>
                        <el-button
                            type='primary'
                            plain
                            icon='el-icon-plus'
                            size='mini'
                            @click='handleAdd'
                        >创建应用
                        </el-button>
                    </el-col>
                    <el-col :span='12'>
                        <el-link href='https://docs.cottongame.com/doc/5lqr5a2y5yko5o6l5ywl-Ns8WBf4yvq' target='_blank'
                                 type='primary'>云存储文档
                        </el-link>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='applicationConfigList'>
                <el-table-column label='应用名' fixed align='center'>
                    <template slot-scope='scope'>
                        <span>{{ getApplicationName(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label='appId' align='center' prop='appId' :show-overflow-tooltip='true' />
                <el-table-column label='appKey' width='300' align='center' prop='appKey' />
                <el-table-column label='masterKey' align='center' prop='masterKey' />
                <el-table-column label='中文名' align='center' prop='chineseName' :show-overflow-tooltip='true' />
                <el-table-column label='项目状态' align='center' prop='status'>
                    <template slot-scope='scope'>
                        <el-tag :type='computeProjectStatusType(scope.row)'>{{ computeProjectStatus(scope.row) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label='创建用户' align='center'>
                    <template slot-scope='scope'>
                        <span>{{ computeUserAccount(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column width='200' label='创建时间' align='center' prop='createdAt' />
                <el-table-column
                    label='操作'
                    align='center'
                    width='200'
                    fixed='right'
                    class-name='small-padding fixed-width'
                >
                    <template slot-scope='scope' v-if='scope.row.userId !== 1'>
                        <el-button
                            size='mini'
                            type='text'
                            icon='el-icon-edit'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            size='mini'
                            type='text'
                            icon='el-icon-s-marketing'
                            @click='handleViewDetail(scope.row)'
                        >查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <!-- 添加或修改用户配置对话框 -->
            <el-dialog :title='title' :visible.sync='open' width='40%' append-to-body @close='cancel'>
                <el-form style='margin-top: 1rem' label-width='150' :model='currentApplicationConfig'
                         ref='insertTrackEvent'>
                    <el-form-item label='应用名' prop='eventId' key='eventId'>
                        <el-input v-if='!updateStatus' size='mini' type='text'
                                  v-model='currentApplicationConfig.appName' autocomplete='off' />
                        <el-tag v-if='updateStatus'>{{ getApplicationName(currentApplicationConfig) }}</el-tag>
                    </el-form-item>
                    
                    <el-form-item label='应用中文名' prop='chineseName' key='chineseName'>
                        <el-input size='mini' type='text'
                                  v-model='currentApplicationConfig.chineseName' autocomplete='off' />
                    </el-form-item>
                    
                    <el-form-item label='项目' prop='projectAppId' key='projectAppId'>
                        <el-select :disabled='updateStatus' size='mini' v-model='currentApplicationConfig.projectAppId'
                                   filterable placeholder='请选择'>
                            <el-option
                                v-for='item in projectInfoList'
                                :key='item.appId'
                                :label='item.cnName'
                                :value='item.appId'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item v-if='updateStatus' label='AppId'>
                        <el-tag>{{ currentApplicationConfig.appId }}</el-tag>
                    </el-form-item>
                    
                    <el-form-item v-if='updateStatus' label='AppKey'>
                        <el-tag>{{ currentApplicationConfig.appKey }}</el-tag>
                    </el-form-item>
                    
                    <el-form-item v-if='updateStatus' label='MasterKey'>
                        <el-tag>{{ currentApplicationConfig.masterKey }}</el-tag>
                    </el-form-item>
                    
                    <el-form-item v-if='updateStatus' label='状态' prop='status' key='status'>
                        <el-select size='mini' v-model='currentApplicationConfig.status' filterable
                                   placeholder='请选择'>
                            <el-option
                                v-for='item in projectStatusOption'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item v-if='updateStatus && currentApplicationConfig.status === "DELETE"' label='删除时间'>
                        <span>{{ currentApplicationConfig.deletedAt }}</span>
                    </el-form-item>
                    
                    <el-form-item label='描述'>
                        <el-input size='mini' type='textarea' v-model='currentApplicationConfig.description'
                                  autocomplete='off' />
                    </el-form-item>
                </el-form>
                
                <div slot='footer' class='dialog-footer'>
                    <div>
                        <el-button v-if='updateStatus' style='float: left' type='danger'
                                   @click='handleDelete(currentApplicationConfig)'>
                            删除应用
                        </el-button>
                        <el-button type='primary' @click='submitForm'>{{ updateStatus ? '修 改' : '添 加' }}</el-button>
                        <el-button @click='cancel'>取 消</el-button>
                    </div>
                </div>
            </el-dialog>
            
            <el-dialog title='应用信息' :visible.sync='openShowInsertSuccessData' width='40%' append-to-body
                       @close='cancelShowSuccessConfig'>
                <el-form style='margin-top: 1rem' label-width='150'
                         ref='insertTrackEvent'>
                    <el-form-item label='应用名' prop='eventId' key='eventId'>
                        <span style='color: #409EFF'
                              @click='copyContent(insertSuccessConfigInfo.appName)'>{{ insertSuccessConfigInfo.appName
                            }}</span>
                    </el-form-item>
                    
                    <el-form-item label='应用中文名' prop='chineseName' key='chineseName'>
                        <span style='color: #409EFF'>{{ insertSuccessConfigInfo.chineseName }}</span>
                    </el-form-item>
                    
                    <el-form-item label='AppId'>
                        <span style='color: #409EFF'
                              @click='copyContent(insertSuccessConfigInfo.appId)'>{{ insertSuccessConfigInfo.appId
                            }}</span>
                    </el-form-item>
                    
                    <el-form-item label='AppKey'>
                        <span style='color: #409EFF'
                              @click='copyContent(insertSuccessConfigInfo.appKey)'>{{ insertSuccessConfigInfo.appKey
                            }}</span>
                    </el-form-item>
                    
                    <el-form-item label='MasterKey'>
                        <span style='color: #409EFF'
                              @click='copyContent(insertSuccessConfigInfo.masterKey)'>{{ insertSuccessConfigInfo.masterKey
                            }}</span>
                    </el-form-item>
                    
                    <el-form-item label='创建时间'>
                        <span>{{ insertSuccessConfigInfo.createdAt }}</span>
                    </el-form-item>
                    
                    <el-form-item label='描述'>
                        <p>{{ insertSuccessConfigInfo.description }}</p>
                    </el-form-item>
                </el-form>
                
                <div slot='footer' class='dialog-footer'>
                    <div>
                        <el-button @click='cancelShowSuccessConfig'>关 闭</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { message } from '@/utils/message';
import { queryProjectInfoList } from '@api/ProjectInfo';
import { selectEmployeeList } from '@api/dashboard';
import CottonDynamicForm from '@/components/component/CottonDynamicForm.vue';
import TrackParameterDynamicForm from '@view/track/eventManage/TrackParameterDynamicForm.vue';
import IconIfyIcon from '@/components/component/icon/IconIfyIcon.vue';
import { applicationCredentialApi } from '@api/Storage/applicaitonCredentialConfig';
import { copyContent } from '@/utils/string/cottonPlugin';

export default {
    name: 'User',
    components: { IconIfyIcon, TrackParameterDynamicForm, CottonDynamicForm },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            // 部门树选项
            projectTreeOptions: [],
            // 是否显示弹出层
            open: false,
            defaultProps: {
                label: 'label'
            },
            queryProjectName: undefined,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                projectAppId: undefined
            },
            
            currentApplicationConfig: {},
            applicationConfigList: [],
            updateStatus: false,
            projectInfoList: [],
            projectStatusOption: [
                {
                    label: '开发',
                    value: 'DEV'
                },
                {
                    label: '测试',
                    value: 'TEST'
                },
                {
                    label: '生产',
                    value: 'PROD'
                }
            ],
            insertSuccessConfigInfo: {},
            openShowInsertSuccessData: false,
            adminUserList: []
        };
    },
    watch: {
        // 根据名称筛选项目组
        queryProjectName(val) {
            this.$refs.tree.filter(val);
        }
    },
    computed: {
        getApplicationName() {
            return (applicationConfig) => {
                return applicationConfig.appName;
            };
        },
        computeUserAccount() {
            return (data) => {
                for (let i = 0; i < this.adminUserList.length; i++) {
                    if (data.createUserId === this.adminUserList[i].userId) {
                        return this.adminUserList[i].account;
                    }
                }
            };
        },
        computeProjectStatus() {
            return data => {
                let status = data.status;
                for (let i = 0; i < this.projectStatusOption.length; i++) {
                    let option = this.projectStatusOption[i];
                    if (option.value === status) {
                        return option.label;
                    }
                }
            };
        },
        computeProjectStatusType() {
            return data => {
                let status = data.status;
                switch (status) {
                    case 'DEV':
                        return '';
                    case 'TEST':
                        return 'warning';
                    case 'PROD':
                        return 'success';
                    
                }
            };
        }
    },
    created() {
        this.getList();
        this.initData();
    },
    methods: {
        copyContent,
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        initData() {
            this.adminUserList = [];
            selectEmployeeList({ pageSize: 10000 }).then(result => {
                this.adminUserList = result.data;
            });
            // 获取所有的项目组
            queryProjectInfoList({ pageSize: 10000 }).then(result => {
                this.projectInfoList = result.data.result;
            });
        },
        getList() {
            this.applicationConfigList = [];
            this.trackEventList = [];
            this.loading = true;
            
            applicationCredentialApi.queryList().then(result => {
                if (result.code === 200) {
                    this.applicationConfigList = result.data;
                }
                
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.currentApplicationConfig = {};
        },
        cancelShowSuccessConfig() {
            this.openShowInsertSuccessData = false;
            
            // 进入应用详情
            this.$router.push(`/storage-info/${this.insertSuccessConfigInfo.appId}/settings`);
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '新建应用';
            this.updateStatus = false;
            this.currentApplicationConfig = {};
        },
        handleRemove() {
            this.open = true;
            this.title = '移除项目组';
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.updateStatus = true;
            this.title = '修改应用信息';
            
            this.currentApplicationConfig = row;
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + this.getApplicationName(row) + '"应用? 应用被删除后，将不可用，15天后数据会被自动删除。删除之前，请确保该应用下的所有Class都已被删除!').then(function() {
                return applicationCredentialApi.deleteConfig(row);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    message.success('删除成功');
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            if (this.updateStatus) {
                applicationCredentialApi.updateConfig(this.currentApplicationConfig).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            } else {
                // 全部都是新增
                applicationCredentialApi.insertConfig(this.currentApplicationConfig).then(result => {
                    if (result.code === 200) {
                        message.success(result.message);
                        this.getList();
                        this.open = false;
                        this.insertSuccessConfigInfo = result.data;
                        this.openShowInsertSuccessData = true;
                    }
                });
            }
        },
        handleViewDetail(data) {
            let appId = data.appId;
            this.$router.push(`/storage-info/${appId}`);
        }
    }
};
</script>
